module.exports = __webpack_public_path__ + "img/road_roller.81625110.png";